import * as ko from 'knockout';
import entityBase from 'entityBase';

export class access_right extends entityBase {
    description       : KnockoutObservable<string>;
    function_id       : KnockoutObservable<string>;
    parent_function_id: KnockoutObservable<string>;
    read_only         : KnockoutObservable<boolean>;
    sequence          : KnockoutObservable<number>;
    sales_company     : KnockoutObservable<string>;
    show_on_homepage  : KnockoutObservable<boolean>;
    show_on_navi      : KnockoutObservable<boolean>;
    subfunction_id    : KnockoutObservable<string>;
    url               : KnockoutObservable<string>;
    access_right      : KnockoutObservable<access_right>;

    constructor(item: any){
        super();
        this.description        = ko.observable(item.description).extend({ maxLength: 50 });
        this.function_id        = ko.observable(item.function_id).extend({ maxLength: 50 });
        this.parent_function_id = ko.observable(item.parent_function_id).extend({ maxLength: 50 });
        this.read_only          = ko.observable(item.read_only);
        this.sequence           = ko.observable(item.sequence);
        this.sales_company      = ko.observable(item.sales_company).extend({ maxLength: 50 });
        this.show_on_homepage   = ko.observable(item.show_on_homepage);
        this.show_on_navi       = ko.observable(item.show_on_navi);
        this.subfunction_id     = ko.observable(item.subfunction_id).extend({ maxLength: 50 });
        this.url                = ko.observable(item.url).extend({ maxLength: 450 });
        this.access_right       = ko.observable();
        if(item.access_right) {
            this.access_right(new access_right(item.access_right));
        }
    }
}


